import { render, staticRenderFns } from "./UpdateTeacherSchedule.vue?vue&type=template&id=d79f26b2"
import script from "./UpdateTeacherSchedule.vue?vue&type=script&lang=js"
export * from "./UpdateTeacherSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports